const currentCategory = (state = {}, action) => {
    switch (action.type) {
        case 'SET_ACTIVE_CATEGORY':
            return {
                ...state,
                activeCategory: action.payload
            };
        default:
            return state;
    }
};

export default currentCategory;
